import React from 'react'
import {bindAll, isEmpty} from 'lodash'
import Checkbox from '../Checkbox'
import * as constant from '../contants'
import {getFPLValue} from "../fpl"
import Fade from '../../Utils/Fade'

const questionName = constant.INCOMELEVEL

export default class IncomeLevel extends React.PureComponent {
    constructor(props) {
        super(props)
        let answer = this.getCurrentAnswer(this.props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.state = {
            checkedYes: answer.options.checkedYes,
            checkedNo: answer.options.checkedNo,
            fplData: []
        }
        bindAll(this, ['getCurrentAnswer', 'setCheckedYes', 'setCheckedNo', 'setToParentState'])
    }

    componentDidMount() {
        this.props.dataApi.fetchFPLData(function (response) {
                if (!isEmpty(response["fpl"])) {
                    let fplData = response["fpl"]
                    this.setState({fplData})
                }
            }.bind(this)
        )
    }

    componentWillReceiveProps(props) {
        let answer = this.getCurrentAnswer(props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.setState({
            checkedYes: answer.options.checkedYes,
            checkedNo: answer.options.checkedNo,
        })
    }

    getCurrentAnswer(props) {
        const {answers} = props
        let currentAnswer = {}
        answers.forEach(answer => {
            if (answer.name === questionName) {
                currentAnswer = answer
            }
        })
        return currentAnswer
    }

    initAnswer() {
        return {
            name: questionName,
            options: {
                checkedYes: false,
                checkedNo: false
            }
        }
    }

    setCheckedYes(checkedYes) {
        let checkedNo = this.state.checkedNo
        if (checkedYes) checkedNo = false
        this.setState({checkedYes, checkedNo})
        this.setToParentState(checkedYes, checkedNo)
    }

    setCheckedNo(checkedNo) {
        let checkedYes = this.state.checkedYes
        if (checkedNo) checkedYes = false
        this.setState({checkedYes, checkedNo})
        this.setToParentState(checkedYes, checkedNo)
    }

    setToParentState(checkedYes, checkedNo) {
        const answer = {
            name: questionName,
            options: {
                checkedYes: checkedYes,
                checkedNo: checkedNo
            }
        }
        this.props.setAnswers(answer)
    }

    render() {
        const {checkedYes, checkedNo, fplData} = this.state
        const {eligibleData} = this.props
        const {answers} = this.props
        console.log(fplData);
        const fpl = getFPLValue(questionName, answers, fplData)
        return (
            <div>
                {
                    !isEmpty(eligibleData) ?
                        <Fade duration={0.5}>
                            <h1 className="question-title text-center">
                                {eligibleData.question.split('xxx').join(fpl)}
                            </h1>
                            <div className="question-content">
                                <Checkbox
                                    title={eligibleData.options[0].title}
                                    checked={checkedYes}
                                    clickHandler={this.setCheckedYes}
                                />
                                <Checkbox
                                    title={eligibleData.options[1].title}
                                    checked={checkedNo}
                                    clickHandler={this.setCheckedNo}
                                />
                            </div>
                        </Fade>
                        :
                        null
                }
            </div>
        )
    }
}